var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"is-size-5"},[_vm._v("Laravel Version Spread")]),_c('div',{attrs:{"id":"version-spread-donut"}},[_c('apexchart',{attrs:{"type":"donut","options":_vm.options,"series":_vm.series}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }